//angular imports
import { Signal } from "@angular/core";

//local imports
import { AbstractProjectNavModel, SelectProjectMessage } from "@app/catalog-common";
import { IListItem, ListItem, Messenger } from "@app/shared";
import { ProjectModel } from "@app/catalog";

export class ProjectsNavModel 
  extends AbstractProjectNavModel<ProjectModel> {

 constructor(
    messenger: Messenger,
    items: Signal<ProjectModel[]>
  ) {
    super(messenger, items);
  }

  public select(item: IListItem): void {
    const navItem = item as ListItem<ProjectModel>;
    this.messenger.send(new SelectProjectMessage(navItem.value));
  }
}